export default __webpack_public_path__ + "static/media/emblem.674d0ad7.png";